import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./NewsSection.css";
import image from "../../assets/images/icons/new-icon1.gif";
import api from "../api";

const NewsSection = () => {
  const [newsData, setNewsData] = useState([]);
  const { i18n, t } = useTranslation();

  useEffect(() => {
      fetchNews(i18n.language);
      //eslint-disable-next-line
    }, [i18n.language]);

  const fetchNews = async () => {
    try {
      const response = await api.get(`/newsupdate?lang=${i18n.language}`);
      const reversedNewsData = response.data.reverse();
      setNewsData(reversedNewsData);
    } catch (error) {
      console.error("Error fetching news", error);
    }
  };

  return (
    <section className="news-section">
      <div className="container-fluid">
        <div className="marquee">
          <div className="news-label">{t("serviceBlock.news")}</div>
          <div className="marquee-content">
            {newsData.map((item, index) => (
              <div
                className="marquee-item"
                key={`${index % newsData.length}-${item.description}`}
              >
                {item.label && item.label.toLowerCase() === "new" && (
                  <img
                    src={image}
                    className="newgif"
                    alt="newgif"
                  />
                )}
                <span style={{ color: "#3EA4ED" }}>
                  {(index % newsData.length) + 1}.{" "}
                </span>
                {item.description}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
